module.exports = __webpack_public_path__ + "img/avatar.c58e4651.png";